var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconCloseSmall = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M17.079 17.079C17.307 16.851 17.307 16.482 17.079 16.254L12.825 12L17.079 7.746C17.307 7.518 17.307 7.149 17.079 6.921C16.851 6.693 16.482 6.693 16.254 6.921L12 11.175L7.746 6.921C7.518 6.693 7.149 6.693 6.921 6.921C6.693 7.149 6.693 7.518 6.921 7.746L11.175 12L6.921 16.254C6.693 16.482 6.693 16.851 6.921 17.079C7.149 17.307 7.518 17.307 7.746 17.079L12 12.825L16.254 17.079C16.482 17.307 16.851 17.307 17.079 17.079Z", fill: "black" }))),
        alt: 'Icon CloseSmall',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconCloseSmall;
//# sourceMappingURL=index.js.map